import { useState } from "react";
import React from "react";
import styles from "../FreeUser/FreeUserMobileNew.module.css";
import Modal from "../Modal/Modal";
import FreeAccount from "../FreeAccount/FreeAccount";
const languages = [
  { code: "en", name: "English", flag: "https://flagcdn.com/us.svg" },
  { code: "fr", name: "French", flag: "https://flagcdn.com/fr.svg" },
  { code: "de", name: "German", flag: "https://flagcdn.com/de.svg" },
];
const FreeUserMobileNew = ({ heroSection }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selected, setSelected] = useState(languages[0]);
  const [open, setOpen] = useState(false);

  const handleSelect = (lang) => {
    setOpen(false);
    if (typeof window !== "undefined" && window.changeGoogleTranslateLanguage) {
      window.changeGoogleTranslateLanguage(lang.code);
    }
    if (lang?.code !== selected?.code) setSelected(lang);
  };

  const {
    titlePrefix = "Get Your",
    titleHighlight = "FREE",
    titleMain = "AI Receptionist",
    titleSuffix1 = "in",
    titleSuffix = "just 3 minutes",
    featuresTitle,
    features = [],
    cta = {},
    heroGif,
  } = heroSection || {};

  const heroGifUrl =
    (typeof heroGif === "string" && heroGif) ||
    heroGif?.url ||
    heroGif?.asset?.url ||
    "Images/RexptGif.gif";

  const joinHref = cta?.joinUrl || "#";
  const watchHref =
    cta?.WatchRexUrl || "https://www.youtube.com/embed/qPuwdJjkBms?autoplay=1";
  return (
    <>
      <div>
        <div className={styles.MobileContainer}>
          <div className={styles.MobileImgDiv}>
            {/* <img
            src="images/Mobile-Bg-Image.png"
            alt="Mobile-Bg-Image"
            className={styles.bgImg}
          /> */}
          </div>
          <div className={styles.logoDiv}>
            <a href="#">
              <img src="/Svg/rexpt-logo.svg" alt="Rexpt Logo" />
            </a>
          </div>

          <div className={styles.rexGif}>

            <video
              className={styles.video}
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
            >
              <source src="Images/RexptGif-New.webm" type="video/webm" />
              
              <source src="Images/RexptGif-New.mp4" type="video/mp4" />
            </video>
            {/* <img src="Images/RexptGif.gif" alt="RexptGif" /> */}
            <div className={styles.HorizontalLine}>
              <svg
                width=""
                height=""
                viewBox="0 0 422 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_d_1051_54)">
                  <ellipse
                    cx="211"
                    cy="7"
                    rx="201"
                    ry="2"
                    fill="url(#paint0_radial_1051_54)"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_1051_54"
                    x="0"
                    y="0"
                    width="422"
                    height="24"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feMorphology
                      radius="5"
                      operator="dilate"
                      in="SourceAlpha"
                      result="effect1_dropShadow_1051_54"
                    />
                    <feOffset dy="5" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_1051_54"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_1051_54"
                      result="shape"
                    />
                  </filter>
                  <radialGradient
                    id="paint0_radial_1051_54"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(211 7) scale(201 2)"
                  >
                    <stop stop-color="#DADADA" />
                    <stop offset="1" stop-color="#B1B6B4" />
                  </radialGradient>
                </defs>
              </svg>
            </div>
          </div>

          <div className={styles.TextSectionBelowRex}>
            <div className={styles.TextFreeUserSection}>
              <h1>
                {titlePrefix}{" "}
                <span className={styles.FreeText}>{titleHighlight}</span>
              </h1>
              <h2>
                {titleMain}
                <span className={styles.INText}>
                  {titleSuffix1 ? ` ${titleSuffix1} ` : " "}
                  <b>{titleSuffix}</b>
                </span>
              </h2>
              <div
                className={styles.joinBtn}
                onClick={() => setIsModalOpen(true)}
              >
                <img src="/Svg/join-rexpt-mob-new.svg" alt="join-rexpt" />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.JoinPoints}>
          <div className={styles.JoinBox}>
            <p>Never miss a Call - <span>Never miss a Client</span></p>

            <ul>

              <div className={styles.ListIconText}>
                <svg width="70" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.91113 1.125C7.19444 1.12129 8.40758 1.71166 9.19336 2.72656L10.1191 3.89941C10.4275 4.2957 10.731 4.69428 11.0176 5.08398C12.0121 6.40266 12.129 8.17275 11.3418 9.60156L11.1719 9.88184C10.3063 11.2368 10.2863 12.828 10.7891 14.3877C11.292 15.9479 12.3171 17.473 13.5332 18.6875C14.7493 19.902 16.2766 20.9247 17.8389 21.4268C19.4007 21.9286 20.9937 21.9088 22.3506 21.0449L22.6318 20.876C24.062 20.0904 25.8329 20.207 27.1533 21.1992C27.937 21.7733 28.7522 22.4156 29.5156 23.0225L29.5918 23.083L29.5869 23.084C30.5428 23.88 31.1045 25.0547 31.1172 26.3008C31.1314 27.5783 30.5685 28.7934 29.585 29.6104C28.8229 30.2439 28.026 30.8466 27.2188 31.4004L27.2178 31.3994C26.5318 31.8826 25.7152 32.1425 24.877 32.1465V32.1494H24.8262L24.6758 32.1475H24.6738C19.3162 31.9757 13.2476 28.4972 8.47852 23.7344C3.85841 19.1202 0.44591 13.2885 0.0810547 8.06348L0.0556641 7.56055C0.017924 6.68457 0.262657 5.82206 0.75 5.0957H0.745117L0.798828 5.01758C1.35334 4.21141 1.95573 3.41795 2.58887 2.6582L2.5957 2.65039L2.60059 2.64746C3.39562 1.66906 4.59789 1.10827 5.85938 1.125H5.91113ZM3.01855 3.72656C2.53115 4.3331 2.0663 4.95815 1.63184 5.58887V5.58984L1.63086 5.58887C1.2293 6.15307 1.02966 6.83538 1.0625 7.52734V7.52832C1.2152 12.2976 4.24949 18.0931 9.18848 23.0254C14.1275 27.9577 19.9311 30.9882 24.707 31.1406L24.9668 31.1416C25.5688 31.1198 26.1541 30.9231 26.6484 30.5723L26.6494 30.5713C27.386 30.0658 28.112 29.5173 28.8096 28.9424L22.1504 22.29C21.4216 22.6077 20.6347 22.7687 19.8398 22.7637V22.7646C17.3397 22.7646 14.7202 21.2976 12.8184 19.3984C11.6155 18.1973 10.587 16.7092 9.99316 15.1465C9.40321 13.594 9.24051 11.9642 9.76855 10.4678L3.01855 3.72656ZM26.5557 22.0117C25.5411 21.2489 24.1721 21.1626 23.0723 21.7881L29.5166 28.2217C30.5045 26.8184 30.2332 24.886 28.8867 23.8105C28.1298 23.2089 27.3244 22.5755 26.5566 22.0117H26.5557ZM19.5176 1.17871C21.7841 -0.130203 24.5299 -0.311181 26.9492 0.688477C29.3685 1.6871 31.1845 3.75262 31.8633 6.27734C32.542 8.80214 32.0068 11.4995 30.415 13.5742C28.8407 15.6241 26.4129 16.8343 23.8301 16.8652L23.833 16.8682H23.7373C21.502 16.872 19.3581 15.9861 17.7793 14.4082C15.9286 12.5599 15.0412 9.95721 15.3818 7.36523C15.7227 4.77301 17.2512 2.48636 19.5176 1.17871ZM23.7373 1.05371C21.7704 1.05371 19.8836 1.83349 18.4922 3.22168V3.22266C17.0959 4.60852 16.3105 6.49339 16.3105 8.45996C16.3106 10.4254 17.0958 12.3107 18.4922 13.6963C19.8836 15.0845 21.7704 15.8643 23.7373 15.8643C25.7041 15.8655 27.5904 15.0856 28.9805 13.6963C30.3718 12.3082 31.1532 10.4241 31.1533 8.45996C31.1533 6.49571 30.3719 4.6112 28.9805 3.22168C27.5904 1.8324 25.7041 1.05373 23.7373 1.05371ZM23.7363 10.7061C24.5647 10.6981 25.2439 11.363 25.252 12.1904V12.1914C25.2518 12.7899 24.8936 13.3301 24.3408 13.5615C23.7892 13.793 23.1512 13.67 22.7236 13.251C22.2961 12.8319 22.1613 12.1988 22.3838 11.6426L22.4287 11.541C22.6715 11.0423 23.1747 10.7177 23.7363 10.7061ZM23.9531 11.751C23.777 11.6765 23.5732 11.7126 23.4346 11.8438C23.2946 11.9766 23.2479 12.178 23.3154 12.3584C23.3813 12.5362 23.5457 12.658 23.7363 12.6689H23.7383C24.01 12.6759 24.2352 12.4626 24.2432 12.1914L24.2383 12.1201C24.2174 11.9811 24.1357 11.8573 24.0156 11.7832L23.9531 11.751ZM24.2061 3.24121C24.4954 3.23716 24.7744 3.35312 24.9746 3.5625C25.1759 3.77048 25.2815 4.05301 25.2666 4.3418L25.0332 9.10352C25.007 9.64317 24.5761 10.0698 24.042 10.0986V10.1025H23.9922L23.4502 10.1064H23.4424C22.8839 10.1078 22.4233 9.67261 22.3945 9.11719L22.3926 9.11523L22.3916 9.09668L22.2051 4.34082C22.1943 4.05733 22.2981 3.78141 22.4941 3.57617C22.6888 3.37103 22.9595 3.25374 23.2432 3.25098L24.2061 3.24121ZM5.7041 2.13379C4.95285 2.15931 4.23492 2.45537 3.68359 2.96777L10.2246 9.49805C10.2559 9.44481 10.2877 9.39164 10.3213 9.33887H10.3223C11.0599 8.21746 11.0129 6.75278 10.2031 5.68066L10.1426 5.60059H10.1445C9.59725 4.85919 8.98514 4.08321 8.40234 3.35352V3.35254C7.803 2.57937 6.87767 2.12916 5.89941 2.13281H5.8584L5.7041 2.13379ZM24.2178 4.24902L23.2549 4.25879H23.249C23.2416 4.25813 23.2332 4.26145 23.2275 4.26855L23.2227 4.27441C23.2158 4.28091 23.2132 4.28828 23.2129 4.29492L23.2139 4.30469L23.4004 9.06055V9.06152C23.401 9.08333 23.4192 9.10148 23.4434 9.10156L23.9834 9.09473H23.9844C24.0072 9.09467 24.0246 9.07707 24.0254 9.05664V9.05469L24.2598 4.29297L24.2607 4.28809C24.2619 4.28032 24.2589 4.27078 24.252 4.26465L24.2432 4.25781L24.2441 4.25684C24.2389 4.24999 24.2309 4.24711 24.2246 4.24805L24.2178 4.24902Z" fill="#6524EB" stroke="#6524EB" stroke-width="0.1" />
                </svg>
                <li class="list-item">
                  Stop losing <span>thousands to Missed Calls</span> every year
                </li>
              </div>

              <div className={styles.ListIconText}>
                <svg width="70" height="33" viewBox="0 0 34 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M32.2937 18.809V9.18925C32.2937 7.41116 31.6007 5.70603 30.3668 4.4491C29.1329 3.19233 27.4589 2.48639 25.7131 2.48639H24.9819V0.624525C24.9819 0.460061 24.9179 0.301802 24.8037 0.185423C24.6894 0.0690443 24.5341 0.00389213 24.3726 0.00389213C24.205 -0.016278 24.039 0.0426808 23.9202 0.1637C23.8014 0.284723 23.7435 0.453841 23.7633 0.624529V2.48639H9.13995V0.624529C9.13995 0.460065 9.07597 0.301806 8.96173 0.185427C8.84748 0.0690483 8.69211 0.0038961 8.53063 0.0038961C8.36307 -0.016274 8.19703 0.0426848 8.0782 0.163704C7.95939 0.284727 7.90151 0.453845 7.92131 0.624533V2.4864H6.51989C4.78034 2.4864 3.11234 3.19388 1.88761 4.45375C0.664435 5.71207 -0.0164656 7.4172 0.000302529 9.18914V29.2973C-0.0164535 31.0691 0.664435 32.7743 1.88761 34.0326C3.1123 35.2925 4.7803 36 6.51989 36H23.0322C25.9416 36 28.7306 34.8224 30.7872 32.7278C32.8436 30.6332 33.9998 27.7922 33.9998 24.8287C34.0135 22.6969 33.4209 20.6055 32.2937 18.809ZM6.52002 3.72779H7.92144V5.58965C7.90164 5.76032 7.95952 5.92944 8.07834 6.05048C8.19715 6.1715 8.36319 6.23046 8.53076 6.21029C8.69223 6.21029 8.8476 6.14512 8.96186 6.02876C9.07611 5.91239 9.14008 5.75413 9.14008 5.58965V3.72779H23.7634V5.58965C23.7436 5.76033 23.8015 5.92944 23.9203 6.05048C24.0391 6.1715 24.2051 6.23046 24.3727 6.21029C24.5342 6.21029 24.6896 6.14513 24.8038 6.02876C24.9181 5.91239 24.982 5.75413 24.982 5.58966V3.7278H25.7132C28.6744 3.7278 31.0751 6.17302 31.0751 9.18926V10.5546H1.21933V9.18926C1.20258 7.74632 1.754 6.35768 2.75022 5.33057C3.74644 4.305 5.10339 3.72779 6.52002 3.72779ZM6.52002 34.7588C5.10339 34.7588 3.74615 34.1817 2.74993 33.1561C1.75371 32.1289 1.20228 30.7403 1.21905 29.2974V11.7961H31.0748V17.1956C28.863 14.7922 25.7234 13.5075 22.4942 13.6813C19.265 13.855 16.2764 15.4718 14.3266 18.0985C12.3753 20.7253 11.664 24.0954 12.3784 27.3071C13.0928 30.5188 15.1644 33.2464 18.0358 34.7593L6.52002 34.7588ZM23.0323 34.7588C20.4473 34.7588 17.9675 33.7131 16.1394 31.8497C14.31 29.9878 13.2833 27.4618 13.2833 24.8288C13.2833 22.1958 14.31 19.67 16.1394 17.808C17.9674 15.9445 20.4473 14.8988 23.0323 14.8988C25.6173 14.8988 28.097 15.9445 29.9251 17.808C31.7546 19.6698 32.7812 22.1958 32.7812 24.8288C32.7812 27.4618 31.7546 29.9876 29.9251 31.8497C28.0972 33.7131 25.6173 34.7588 23.0323 34.7588ZM23.6416 18.809V24.8289C23.6614 24.9996 23.6035 25.1687 23.4847 25.2897C23.3659 25.4107 23.1999 25.4697 23.0323 25.4495H19.2546C18.9179 25.4495 18.6453 25.1718 18.6453 24.8289C18.6453 24.486 18.9179 24.2083 19.2546 24.2083H22.423V18.8088C22.4519 18.4783 22.7078 18.2176 23.0323 18.1882C23.3689 18.1882 23.6416 18.4661 23.6416 18.809Z" fill="#6524EB" />
                </svg>
                <li class="list-item">



                  Automatically <span>Manage Appointment</span> Bookings</li>
              </div>
              <div className={styles.ListIconText}>
                <svg width="70" height="33" viewBox="0 0 39 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M37.6924 0H31.3951C30.9078 0 30.4865 0.295398 30.2656 0.727572L15.7039 1.58916C14.3003 1.67395 12.9754 2.3878 12.0718 3.55027L8.26441 8.45163C7.49786 9.43904 7.07654 10.6917 7.07654 11.98V14.7889C4.6906 16.3234 3.08648 19.1241 3.08648 22.33C3.08648 23.8563 3.44437 25.3195 4.12717 26.6215H0V28H22.4838V26.6215H18.3567C18.8567 25.6696 19.1816 24.6248 19.3187 23.5335L24.2123 18.2684C26.2581 17.5408 27.9283 16.1951 29.3065 14.1711H30.1187V14.5294C30.1187 15.3007 30.6975 15.9216 31.4107 15.9216H37.708C38.4238 15.9216 39 15.298 39 14.5294V1.39235C39 0.621016 38.4213 0.000153584 37.708 0.000153584L37.6924 0ZM16.8331 26.6291H11.8759V26.5388C12.6095 26.2516 13.1425 25.5022 13.1425 24.6133V23.3961C13.1425 22.4306 12.414 21.6539 11.5256 21.6539H10.9545C10.7667 21.6539 10.6093 21.487 10.6093 21.2819V20.0702C10.6093 19.6982 10.8885 19.3919 11.2388 19.3919C11.5891 19.3919 11.8683 19.6927 11.8683 20.0702V20.155H13.1476V20.0702C13.1476 19.1813 12.6145 18.4319 11.881 18.1447V16.6814H10.6017V18.1447C9.86817 18.4318 9.33516 19.1813 9.33516 20.0702V21.2819C9.33516 22.2474 10.0636 23.0242 10.952 23.0242H11.5231C11.7109 23.0242 11.8683 23.191 11.8683 23.3961V24.6133C11.8683 24.9853 11.5891 25.2916 11.2388 25.2916C10.8886 25.2916 10.6094 24.9907 10.6094 24.6133V24.5285H9.33006V24.6133C9.33006 25.5022 9.86309 26.2599 10.5966 26.5388V26.6291H5.63948C4.80697 25.3764 4.36018 23.8995 4.36018 22.3377C4.36018 18.2569 7.44666 14.931 11.2336 14.931C15.0205 14.931 18.107 18.2569 18.107 22.3377C18.107 23.8995 17.6654 25.3764 16.8277 26.6291H16.8331ZM13.5334 13.9136V13.8096L15.5335 12.0045L17.7113 12.4175L18.0819 15.3386L17.1656 16.326C16.1833 15.2046 14.9421 14.3649 13.541 13.9164L13.5334 13.9136ZM30.1029 12.8004H28.6282L28.4404 13.0958C27.1611 15.076 25.6001 16.3588 23.6711 17.0097L23.5213 17.059L19.3561 21.5391C19.2266 20.0047 18.7393 18.5906 17.9728 17.3871L19.4272 15.8199L18.8485 11.2276L15.1629 10.5356L12.2516 13.1695V13.6318C11.9191 13.5908 11.5815 13.5552 11.2312 13.5552C10.2109 13.5552 9.2438 13.7658 8.34021 14.135V11.9989C8.34021 11.0334 8.65749 10.0952 9.23113 9.35131L13.0461 4.44176C13.7213 3.56652 14.7162 3.03318 15.7696 2.97023L30.1032 2.12237L30.1029 12.8004ZM37.6872 14.5509L31.3772 14.5372V1.40016L31.3899 1.38648L37.6999 1.40016L37.6872 14.5509Z" fill="#6524EB" />
                </svg>
                <li class="list-item">


                  <span>SAVE up to 87%</span> compared to your current System</li>
              </div>
            </ul>

            {/* <p>{featuresTitle}</p>
            <ul>
              {" "}
              {Array.isArray(features) &&
                features.map((f, idx) => <li key={idx}>{f}</li>)}
            </ul> */}
          </div>
        </div>
      </div>
      {/* <div className={styles.languageDiv}>
        <div className={`${styles.dropdown} ${open ? styles.open : ""}`}>
          <button
            className={styles.dropdownToggle}
            onClick={() => setOpen(!open)}
          >
            <img src={selected.flag} alt={selected.name} />
            <span>{selected.name}</span>
            <span className={styles.arrow}>
              <svg
                width="14"
                height="9"
                viewBox="0 0 14 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.646447 1.14645C0.841709 0.951184 1.15829 0.951184 1.35355 1.14645L7 6.79289L12.6464 1.14645C12.8417 0.951184 13.1583 0.951184 13.3536 1.14645C13.5488 1.34171 13.5488 1.65829 13.3536 1.85355L7.35355 7.85355C7.15829 8.04882 6.84171 8.04882 6.64645 7.85355L0.646447 1.85355C0.451184 1.65829 0.451184 1.34171 0.646447 1.14645Z"
                  fill="#24252C"
                  stroke="#24252C"
                  stroke-width="0.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </button>

          <ul className={styles.dropdownMenu}>
            {languages.map((lang) => (
              <li
                key={lang.code}
                onClick={() => handleSelect(lang)}
                className={styles.dropdownItem}
              >
                <img src={lang.flag} alt={lang.name} />
                <span>{lang.name}</span>
              </li>
            ))}
          </ul>
        </div>
      </div> */}

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        bgColor="transparent"
        boxShadow="unset"
        closeColor="#fff"
        // height="95dvh"
        maxWidth="500px"
      >
        <FreeAccount coming="5" closeModal={() => setIsModalOpen(false)} />
      </Modal>
    </>
  );
};

export default FreeUserMobileNew;
